// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2019-01-25T10:29:38Z                      #

// ##############################################################

import ErrorApi from "./../../../utils/ErrorApi";
import Fetch from "./../../../utils/Fetch";
import ParamsFetch from "./../../../utils/ParamsFetch";
import JsonFetch from "./../../../utils/JsonFetch";
import generateUrl from './../../../utils/generateUrl';

import * as UpdateMethods from "./UpdateMethods";

/**
 * Rozhraní pro práci s geodaty. Generated from cz.marbes.api.objekt.GeodataService.
 */
export default class GeodataApi {
    /**
     * Vrátí geometrii vykreslující danou adresu. <p> Výslednou geometrií může být {@link org.geojson.LineString}, {@link org.geojson.Point} nebo {@link org.geojson.GeometryCollection} obsahující předchozí uvedené.
     *
     * @param popis uživatelský popis adresy
     * @return geometrie
     */
    static getAdresaGeometryByPopis(popis : string) : Promise<GeometryResult> {
        const uri = serverContextPath + `/api/obj/geodata/adresa/geometry`;
        const headers = undefined;
        const params = { popis };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * Vrátí uživatelsk popis adresy, která se nachází pod daným geometrickým objektem.
     *
     * @param geometry {@link org.geojson.Geometry} nebo {@link org.geojson.GeometryCollection}
     * @return uživatelský popis adresy
     */
    static getAdresaPopisByGeometry(geometry : GeoJsonObject) : Promise<string> {
        const uri = serverContextPath + `/api/obj/geodata/adresa/popis`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.post(uri, params, geometry, headers));
    }

    /**
     * Vrátí objekty popisující geometrický útvar
     *
     * @param geometry - {@link org.geojson.Geometry} nebo {@link org.geojson.GeometryCollection}
     * @return - objekty popisující části geometrie
     */
    static getPopisGeometry(geometry : GeoJsonObject) : Promise<AbstractObjectDescription[]> {
        const uri = serverContextPath + `/api/obj/geodata/popis/geometry`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.post(uri, params, geometry, headers));
    }

}